// extracted by mini-css-extract-plugin
export default {"container":"QZ-z","list":"RZ-z"};